<template>
    <layout title="Profile">
        <div>
            <div class="sm:hidden">
                <label for="tabs" class="sr-only">Select a tab</label>
                <!--
                <select v-model="showTab" id="tabs" name="tabs" class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md">
                    <option value="account" selected>My Account</option>
                    <option  v-if="user.role === $GIN_ROLE" value="notifications">Notifications</option>
                    <option  v-if="user.role === $GIN_ROLE" value="bank_accounts">Bank Accounts</option>
                    <option  v-if="user.role === $GIN_ROLE" value="balances">Balances</option>
                    <option  v-if="user.role === $GIN_ROLE" value="marketing_agreement">Marketing Agreement</option>
                </select>
                -->
            </div>
            <div class="hidden sm:block">
                <div class="border-b border-gray-200">
                    <nav class="-mb-px flex" aria-label="Tabs">
                        <inertia-link :href="route('users.profile', user.id)"
                           :class="{ 'active-tab' : showTab === 'account', 'tab' : showTab !== 'account' }">
                            My Account
                        </inertia-link>
                        <!--
                        <inertia-link
                            v-if="user.role === $GIN_ROLE"
                            :href="route('users.notificationEmails', user.id)"
                            :class="{ 'active-tab' : showTab === 'notifications', 'tab' : showTab !== 'notifications' }">
                            Notifications
                        </inertia-link>
                        <inertia-link
                            v-if="user.role === $GIN_ROLE"
                            :href="route('users.bankAccounts', user.id)"
                            :class="{ 'active-tab' : showTab === 'bank_accounts', 'tab' : showTab !== 'bank_accounts' }">
                            Bank Accounts
                        </inertia-link>
                        <inertia-link
                            v-if="user.role === $GIN_ROLE"
                            :href="route('users.yearEndBalances', user.id)"
                            :class="{ 'active-tab' : showTab === 'balances', 'tab' : showTab !== 'balances' }">
                            Balances
                        </inertia-link>
                        <inertia-link
                            v-if="user.role === $GIN_ROLE"
                            :href="route('users.marketing-agreement', user.id)"
                            :class="{ 'active-tab' : showTab === 'marketing_agreement', 'tab' : showTab !== 'marketing_agreement' }">
                            Marketing Agreement
                        </inertia-link>
                        -->
                    </nav>
                </div>
            </div>
        </div>
        <div class="mt-5 md:mt-4 md:col-span-2">
            <account :roles="roles" :user="user" v-if="showTab === 'account'"></account>
            <notifications :emails="emails" :user="user" v-if="showTab === 'notifications'"></notifications>
            <bank-accounts :accounts="accounts" :user="user" v-if="showTab === 'bank_accounts'"></bank-accounts>
            <balances :balances="balances" :user="user" :history="history" v-if="showTab === 'balances'"></balances>
            <marketing-agreement :user="user" v-if="showTab === 'marketing_agreement'"></marketing-agreement>
        </div>
    </layout>
</template>


<script>
import Layout from '@/Shared/Layout'
import Account from '@/Components/Profile/Account'
import Notifications from '@/Components/Profile/Notifications'
import BankAccounts from '@/Components/Profile/BankAccounts'
import Balances from '@/Components/Profile/Balances'
import MarketingAgreement from '@/Components/Profile/MarketingAgreement'

export default {
    components: {
        Layout,
        Account,
        Notifications,
        BankAccounts,
        Balances,
        MarketingAgreement
    },
    metaInfo() {
        return {
            title: `Profile`,
        }
    },
    props: {
        user: Object,
        roles: Array,
        tab: String,
        emails: Array,
        accounts: Array,
        balances: Array,
        history: Array,
    },
    data() {
        return {
            showTab: this.tab ?? 'account'
        }
    }
}
</script>

